"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { isAuthPathname } from "@/features/auth/lib/auth-routes";

/**
 * Site chrome (promo banners, the main footer) is rendered from the root layout,
 * which route groups cannot opt out of. Auth screens bring their own minimal
 * header and footer, so the shared chrome is skipped for them here.
 */
export const HideOnAuthRoutes = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();

  if (isAuthPathname(pathname)) {
    return null;
  }

  return children;
};
